import { load } from "@cashfreepayments/cashfree-js";
import { shopApi } from "./shop";
import { consultApi } from "./consult";

let sdk = null;

const openCheckout = async (data) => {
    if (!sdk) sdk = await load({ mode: data.mode === "production" ? "production" : "sandbox" });
    return sdk.checkout({ paymentSessionId: data.payment_session_id, redirectTarget: "_self" });
};

/** Opens Cashfree's hosted checkout for an order that is waiting for payment. */
export const startCashfreePayment = async (orderNumber) => {
    const { data } = await shopApi.post("/payments/cashfree/session", { order_number: orderNumber });
    return openCheckout(data);
};

/** Opens Cashfree's hosted checkout for a consultation that is waiting for payment. */
export const startConsultPayment = async (bookingId) => {
    const { data } = await consultApi.post("/payments/cashfree/session", { booking_id: bookingId });
    return openCheckout(data);
};

export const fetchConsultPaymentStatus = async (bookingId) =>
    (await consultApi.get(`/payments/cashfree/status/${bookingId}`)).data;

export const fetchPaymentStatus = async (orderNumber) =>
    (await shopApi.get(`/payments/cashfree/status/${orderNumber}`)).data;
